import angular from 'angular';

ContactsTypeaheadDirective.$inject = [];

function ContactsTypeaheadDirective() {
  ContactsTypeaheadController.$inject = ['$scope', '$timeout', '$filter', 'ApiService', 'GridStateFactory'];

  function ContactsTypeaheadController($scope, $timeout, $filter, ApiService, GridStateFactory) {
    $scope.contactsTypeahead = {
      list: [],
      errorMessage: '',
      selectedContact: '',
      lastSearchQuery: '',
      lastSelected: '',
      totalServerItems: 0,
      pageSize: -1,
      showMoreContacts: false,
      contactsGridState: new GridStateFactory(),
      showAddContact: {
        addNewLabel: 'New Contact',
        addNew: true,
      },

      init: function () {
        if ($scope.organizationId) {
          this.getContacts($scope.organizationId);
          $scope.$on('$destroy', $scope.$watch('contactsTypeahead.selectedContact', this.onSelectedContactUpdate));
          $scope.$on('$destroy', $scope.$watch('organizationId', this.onOrganizationIdUpdate));
          $scope.$on('$destroy', $scope.$on('ContactsTypeahead::Refresh', this.onRefresh));
        }
        if (!$scope.addContact) {
          this.showAddContact.addNew = false;
        }
      },

      getContacts: function (organizationId) {
        this.contactsGridState.updateGridState(null, null, 'name', 'asc', '');
        this.contactsGridState.gridState.search = '';
        ApiService.organizations.contacts
          .list(angular.extend({ organizationId: organizationId }, this.contactsGridState.getGridState()))
          .then(this.success.getContacts, this.error.getContacts);
      },

      searchContacts: function (organizationId, field) {
        this.searching = true;
        ApiService.organizations.contacts
          .list(angular.extend({ organizationId: organizationId }, this.contactsGridState.getGridState()))
          .then(function (response) {
            $scope.contactsTypeahead.success.searchContacts(response, field);
          }, this.error.searchContacts);
      },

      addContact: function () {
        if ($scope.addContact) {
          $scope.addContact();
        }
        $scope.$emit('ContactsTypeahead::AddContact');
      },

      filterContactList: function (force, field) {
        const timeoutMS = force ? 0 : 500;

        if (this.queryTimer) {
          $timeout.cancel(this.queryTimer);
        }

        this.queryTimer = $timeout(function () {
          const self = $scope.contactsTypeahead;

          if (force || (typeof self.selectedContact === 'string' && self.lastSearchQuery !== self.selectedContact)) {
            if (!force) {
              self.contactsGridState.setPropertyValue('pageSize', self.pageSize);
            } else {
              self.contactsGridState.setPropertyValue(
                'pageSize',
                self.contactsGridState.gridState.pageSize + self.pageSize
              );
            }
            self.contactsGridState.gridState.search = self.hasSelectedContact() ? '' : self.selectedContact;
            self.lastSearchQuery = self.contactsGridState.gridState.search;
            if ($scope.organizationId) {
              self.searchContacts($scope.organizationId, field);
            }
          }
        }, timeoutMS);
      },

      showMoreContactResults: function (item) {
        let _id = 'contacts-typeahead-list';

        if ($scope.id) {
          _id = 'contacts-typeahead-list-' + $scope.id;
        }

        switch (item.field) {
          case _id:
            this.filterContactList(true, item.field);
            break;
        }
      },

      resetSelectedContact: function () {
        const self = $scope.contactsTypeahead;
        let foundContact;

        $timeout(function () {
          //reset selected contact if no contact is chosen
          if (!self.hasSelectedContact()) {
            if (self.hasLastSelectedContact()) {
              self.selectedContact = self.lastSelected;
            } else {
              foundContact = self.findContact(self.list, $scope.current);
              if (foundContact) {
                self.selectedContact = self.list[foundContact.index];
              }
            }
          }
          self.reduceList = false;
        }, 0);
      },

      findContact: function (list, order) {
        let result: { index: number; contact: any } | false = false;

        if (order) {
          for (let i = 0, ii = list.length; i < ii; i++) {
            // No ID present so we need to do a
            // lookup based on other matching fields
            if (
              list[i].firstName === order.contactFirstName &&
              list[i].lastName === order.contactLastName &&
              list[i].phoneNumber === order.phoneNumber &&
              list[i].email === order.email
            ) {
              result = {
                index: i,
                contact: list[i],
              };
              break;
            }
          }
        }

        return result;
      },

      findByField: function (list, field, value) {
        let result: { index: number; contact: any } | false = false;

        if (field) {
          for (let i = 0, ii = list.length; i < ii; i++) {
            // No ID present so we need to do a
            // lookup based on other matching fields
            // If a value is provided then check both the property and the
            // value exist otherwise only check if the property exists and
            // break on the first hit
            if (list[i].hasOwnProperty(field)) {
              result = {
                index: i,
                contact: list[i],
              };

              if (!value) {
                // If no value select first with property
                break;
              } else if (value !== undefined && list[i][field] == value) {
                // If value
                // Intentional type coercion ==
                break;
              }
            }
          }
        }

        return result;
      },

      hasSelectedContact: function () {
        return this.selectedContact && typeof this.selectedContact === 'object';
      },

      hasLastSelectedContact: function () {
        return this.lastSelected && typeof this.lastSelected === 'object';
      },

      showAutoComplete: function (field) {
        const input = $('#' + field);

        this.reduceType = false;
        this.reduceList = false;

        $timeout(function () {
          input.trigger('focus');
        }, 0);
      },

      processContacts: function (contacts, count) {
        let tmp;
        let result = contacts;
        const currentCount = (this.contactsGridState.gridState.page || 1) * this.contactsGridState.gridState.pageSize;

        for (let i = 0, ii = contacts.length; i < ii; i++) {
          contacts[i].name = '';

          if (contacts[i].firstName) {
            contacts[i].name = contacts[i].firstName;
          }

          if (contacts[i].lastName) {
            if (contacts[i].firstName) {
              contacts[i].name += ' ';
            }
            contacts[i].name += contacts[i].lastName;
          }
        }

        result = $filter('orderBy')(contacts, 'name');

        for (let i = 0, ii = result.length; i < ii; i++) {
          if (result[i].primary) {
            tmp = result.splice(i, 1);
            result.splice(0, 0, tmp[0]);
            break;
          }
        }

        //if there are more items for this search, show pagination
        if (count && count > currentCount) {
          this.showMoreContacts = {
            showMoreLabel: 'Show ' + this.pageSize + ' more of ' + count,
            hasMore: true,
          };
        } else {
          this.showMoreContacts = {
            showMoreLabel: '',
            hasMore: false,
          };
        }
        return result;
      },

      success: {
        getContacts: function (response) {
          const self = $scope.contactsTypeahead;
          let found;

          self.totalServerItems = response.data.payload.pagination.count;

          self.list = self.processContacts(response.data.payload.list, self.totalServerItems);

          if ($scope.current) {
            found = self.findContact(self.list, $scope.current);
          } else if ($scope.autoSelectField) {
            found = self.findByField(self.list, $scope.autoSelectField, $scope.autoSelectValue);
          }

          if (found) {
            self.selectedContact = found.contact;
          } else if (self.list.length) {
            self.selectedContact = self.list[0];
            $scope.$emit('ContactsTypeahead::ContactNotFound', { organizationId: $scope.organizationId });
          } else {
            $scope.$emit('ContactsTypeahead::NoResults', { organizationId: $scope.organizationId });
          }
          self.isLoaded = true;
        },

        searchContacts: function (response, field) {
          const self = $scope.contactsTypeahead;

          self.totalServerItems = response.data.payload.pagination.count;

          self.list = self.processContacts(response.data.payload.list, self.totalServerItems);

          self.searching = false;

          if (field) {
            $scope.$broadcast('CustomTypeahead::FilterResults', { field: field });
          }
        },
      },

      error: {
        getContacts: function (response) {
          const self = $scope.contactsTypeahead;

          self.list = [];

          self.searching = false;
          self.errorMessage = 'Error while getting contacts: ' + response.data.error;
        },
        searchContacts: function (response) {
          const self = $scope.contactsTypeahead;

          self.list = [];

          self.searching = false;
          self.errorMessage = 'Error while searching contacts: ' + response.data.error;
        },
      },

      onSelectedContactUpdate: function (n, o) {
        if (o) {
          $scope.contactsTypeahead.lastSelected = o;
        }
        if (n !== o) {
          $scope.selected = n;
        }
      },

      onOrganizationIdUpdate: function (n, o) {
        if (n !== o) {
          $scope.contactsTypeahead.getContacts(n);
        }
      },

      onRefresh: function (e, data) {
        $scope.contactsTypeahead.getContacts(data.organizationId);
      },
    };

    $scope.contactsTypeahead.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/contactsTypeahead/contactsTypeahead.tpl.html',
    scope: {
      id: '@',
      label: '@',
      autoSelectField: '@',
      autoSelectValue: '@',
      current: '=?',
      selected: '=',
      organizationId: '=',
      addContact: '&?',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: ContactsTypeaheadController,
  };
}

export const ContactsTypeaheadDirectiveModule = angular
  .module('acme.common.directive.contactsTypeahead', ['acme.common.service.api', 'acme.common.factory.gridState'])
  .directive('contactsTypeahead', ContactsTypeaheadDirective).name;
